import { SpecialNeedEnum } from '../../API/guest-management/enum/special-need.enum';

interface ISpecialNeedOption {
  label: string;
  value: SpecialNeedEnum;
}
export function getGuestSpecialNeedOptions(): ISpecialNeedOption[] {
  return [
    {
      label: SpecialNeedEnum.HANDICAPPED,
      value: SpecialNeedEnum.HANDICAPPED,
    },
    {
      label: SpecialNeedEnum.PRIORITY,
      value: SpecialNeedEnum.PRIORITY,
    },
    {
      label: SpecialNeedEnum.LUGGAGE,
      value: SpecialNeedEnum.LUGGAGE,
    },
    {
      label: SpecialNeedEnum.SERVICE,
      value: SpecialNeedEnum.SERVICE,
    },
  ];
}
